import LandingSlider from "areas/landing/elements/landing-slider"
import { Box } from "components/common"
import { jewlr_t } from "helpers/application"
import { SectionDescription, SectionTitle } from "jewlr/pages/components"

const SoMuchMore = () => (
  <>
    <Box
      bg="#F1F1F2"
      pb={2}
      pl={{ _: 4, tablet: 2 }}
      pr={2}
      pt={{ _: 4, tablet: "26px" }}
    >
      <SectionTitle>So Much More</SectionTitle>
      <SectionDescription>
        Explore our extensive collections of {jewlr_t("terms.personalized")}{" "}
        {jewlr_t("terms.jewelry")}.
      </SectionDescription>
    </Box>
    <LandingSlider
      element={{
        items: [
          {
            cta: {
              text: "Shop Now",
            },
            folder: "2020-new-landing-collections/for-her/rev-v1/necklaces",
            link: "/necklaces",
            style: {
              pl: "16px",
              width: { _: "70vw", tablet: "100%" },
            },
            title: {
              text: "Necklaces",
            },
            type: "image",
          },
          {
            cta: {
              text: "Shop Now",
            },
            folder: "2020-new-landing-collections/for-her/rev-v1/bracelets",
            link: "/bracelets",
            style: {
              pl: "16px",
              width: { _: "70vw", tablet: "100%" },
            },
            title: {
              text: "Bracelets",
            },
            type: "image",
          },
          {
            cta: {
              text: "Shop Now",
            },
            folder: "2020-new-landing-collections/for-her/rev-v1/earrings",
            link: "/earrings",
            style: {
              pl: "16px",
              width: { _: "70vw", tablet: "100%" },
            },
            title: {
              text: "Earrings",
            },
            type: "image",
          },
          {
            cta: {
              text: "Shop Now",
            },
            folder: "2020-new-landing-collections/for-her/rev-v1/wedding-bands",
            link: "/bands-for-her",
            style: {
              pl: "16px",
              width: { _: "70vw", tablet: "100%" },
            },
            title: {
              text: "Wedding Bands",
            },
            type: "image",
          },
        ],
        slider_type: "native",
        style: {
          slider_box_style: {
            bg: "#F1F1F2",
            mx: { tablet: "-16px" },
            pb: 3,
            pr: {
              tablet: "16px",
            },
          },
          style: {
            "--base-basis": "70vw",
            "--tablet-basis": "33%",
          },
        },
      }}
    />
  </>
)

export default SoMuchMore
